/** Valeur observable dont la dernière valeur est rejouée aux abonnés tardifs. */
export interface Latest<T> {
  get(): T;
  set(value: T): void;
  subscribe(listener: (value: T) => void): () => void;
}

export function createLatest<T>(initial: T): Latest<T> {
  let value = initial;
  let hasValue = false;
  const listeners = new Set<(value: T) => void>();
  return {
    get: () => value,
    set(v) {
      value = v;
      hasValue = true;
      for (const l of listeners) l(v);
    },
    subscribe(listener) {
      listeners.add(listener);
      if (hasValue) listener(value);
      return () => listeners.delete(listener);
    },
  };
}

/** Flux de messages gardés (file bornée) tant que personne n'écoute. */
export interface Buffered<T> {
  push(message: T): void;
  subscribe(listener: (message: T) => void): () => void;
}

export function createBuffered<T>(max = 200): Buffered<T> {
  const queue: T[] = [];
  const listeners = new Set<(message: T) => void>();
  return {
    push(message) {
      if (listeners.size === 0) {
        queue.push(message);
        if (queue.length > max) queue.shift();
        return;
      }
      for (const l of listeners) l(message);
    },
    subscribe(listener) {
      listeners.add(listener);
      for (const m of queue.splice(0)) listener(m);
      return () => listeners.delete(listener);
    },
  };
}
